<template>
  <div class="hc-dropdown-menu-box">
    <slot></slot>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.hc-dropdown-menu-box {
  padding: 4px 0;
}
</style>
